export default "/images/framework/Morepuzzle.f380e89e.svg?f380e89e";